import * as React from "react";
import Modal from "../../ui/modal/Modal";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./workspaceModal.scss";

interface IProps {
	viewName: string;
	onClose: () => void;
	onSave: () => void;
	isGlobal: boolean;
}

interface IState {
	isLoading: boolean;
}

export default class DeleteViewModal extends React.PureComponent<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {isLoading: false};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose}
				   title={<span>Delete <strong>{this.props.viewName}</strong>{` from ${this.props.isGlobal ? "Shared" : "Your"} views?`} </span>}
				   autoWidth
				   customClass={"c-workspace-modal"}>
				<div className={"c-buttons-box"}>
					<ButtonSecondary label={"Cancel"} onClick={this.props.onClose}/>
					<ButtonPrimary label={"Delete"}
								   onClick={() => this.setState({isLoading: true}, () => this.props.onSave())}
								   disabled={this.state.isLoading}
								   isLoading={this.state.isLoading}/>
				</div>
			</Modal>
		)
	}
}